import React from 'react'
import {Field, change as changeFieldValue, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import $ from 'jquery';
import {renderFieldCheck, renderTextArea, required} from '../../util/inputs'
import cancelarReservas from '../../actions/reserva/cancelarReservas';
import {formatarReal} from '../../util/numberUtil';
import {showSuccessMsg} from '../../util/messagesUtil';
import { validaPerfis } from '../../security/Autorizacao';
import { 
  getAdminEmpresa, 
  getGestorEmpresa, 
  getOperadorEmpresa, 
  getOperadorRemarcacao 
} from '../../security/securityContext';

export class ModalConfirmacaoCancelamentoReserva extends React.Component {
  fecharModal () {
    $('#modalConfirmacaoCancelamentoReservas')
      .modal('hide');
    $('#modalConfirmacaoCancelamentoReservas')
      .hide();
    $('.modal-backdrop')
      .hide();
     
    this.props.limparHabilitadoZerarValorMultaCancelamento();
  }

  validarPerfisAdminEmpresaOuGestorEmpresaOuOperadorEmpresa() {
    return (validaPerfis([getAdminEmpresa(this.props.empresaSelecionada.id)]) ||
                (validaPerfis([getGestorEmpresa(this.props.empresaSelecionada.id)]) && validaPerfis([getOperadorRemarcacao(this.props.empresaSelecionada.id)])) ||
                    (validaPerfis([getOperadorEmpresa(this.props.empresaSelecionada.id)]) && validaPerfis([getOperadorRemarcacao(this.props.empresaSelecionada.id)])));
    
  }

  submit (values) {
    this.props.cancelarReservas(this.props.empresaSelecionada.id, values.observacao, this.props.habilitadoZerarValorMultaCancelamento, this.props.reservas.filter(f => f.selecionada)
      .map(it => it.id))
      .then(() => {
          showSuccessMsg('Reservas canceladas com sucesso');
          this.fecharModal();
          this.props.buscarPedidos()
      })
  }

  exibirTaxaRemarcacao () {
    let taxa = 0.00;
    let valorTotal = 0.00;
    let estorno = 0.00;
    let pedagio = 0.00;
    if (this.props.reservas && this.props.reservas.filter(f => f.selecionada).length > 0) {
      this.props.reservas.filter(f => f.selecionada)
        .forEach(reserva => {
          if (this.validarPerfisAdminEmpresaOuGestorEmpresaOuOperadorEmpresa() && this.props.habilitadoZerarValorMultaCancelamento) {
            taxa = 0.00;
          } else {
            taxa += Number(reserva.valorTaxaRemarcacao);
          }
          pedagio += Number(reserva.pedagio);
          valorTotal += formatarReal(reserva.taxaEmbarque) ? (Number(reserva.taxaEmbarque) + Number(reserva.tarifaSeguro) + Number(reserva.valor)) : reserva.valor;
        })
      estorno = valorTotal - taxa + pedagio;
    }

    return <div className="form-row ml-2">
      <div className='col-12 col-sm-4 col-md-4'>
        <strong className='row float-left'>
          <h6>Total:</h6><h6 className='ml-1' style={{ color: '#fa8d42' }}>
          {valorTotal
            .toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL'
            })}</h6>
        </strong>
      </div>
      <div className='col-12 col-sm-4 col-md-4'>
        <strong className='row float-left'>
          <h6>Taxa:</h6><h6 className='ml-1' style={{ color: '#fa8d42' }}>
          {(taxa + pedagio)
            .toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL'
            })}</h6>
        </strong>
      </div>
      <div className='col-12 col-sm-4 col-md-4'>
        <strong className='row float-left'>
          <h6>Estorno:</h6><h6 className='ml-1' style={{ color: '#fa8d42' }}>
          {estorno
            .toLocaleString('pt-br', {
              style: 'currency',
              currency: 'BRL'
            })}</h6>
        </strong>
      </div>
    </div>

  }

  exibirReservas () {
    return <div className='mt-4 ml-2'>
      Reservas:
      <ul>
        {this.props.reservas.filter(f => f.selecionada)
          .map(reserva => <React.Fragment key={reserva.id}>
            <li>{reserva.descCidadeOrigem} -&gt; {reserva.descCidadeDestino}: {reserva.passageiroDto.nome}</li>
          </React.Fragment>)}
      </ul>
    </div>
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;
    return (
      <div className="modal fade" id="modalConfirmacaoCancelamentoReservas" tabIndex="-1" role="dialog"
           aria-labelledby="modalConfirmacaoCancelamentoReservas" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <form onSubmit={handleSubmit(this.submit.bind(this))}>
              <div className="modal-body">
                {this.props.reservas && this.props.reservas.filter(f => f.selecionada)
                  ?
                  <React.Fragment>
                    {this.exibirTaxaRemarcacao()}
                    {this.validarPerfisAdminEmpresaOuGestorEmpresaOuOperadorEmpresa() && <div className="d-flex justify-content-start">
                              <Field name="habilitadoZerarValorMultaCancelamento" type="checkbox" component={renderFieldCheck}
                                      label="Zerar valor de multa cancelamento"
                                      css="form-check-input" readOnly={false} className="form-check-input"
                                      onChange={(e) => this.props.handleHabilitadoZerarValorMultaCancelamento(e)}/>
                          </div>}
                    {this.exibirReservas()}
                    <Field name='observacao' css="form-control col-md-12" component={renderTextArea} max={1500} validate={[required]} className="form-control" label="Motivo do cancelamento:"/>
                  </React.Fragment>
                  : ''}
              </div>
              <div className="modal-footer ">
                <button id='cancelar' type="button" className="btn btn-outline-secondary"
                        data-dismiss="modal" onClick={() => {
                          this.props.changeFieldValue('formularioCancelamentoReserva', 'habilitadoZerarValorMultaCancelamento', false);
                          this.props.limparHabilitadoZerarValorMultaCancelamento();
                        }}>Não
                </button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="btn btn-laranja">Sim
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => (
  {
    reservas: state.remarcacao.reservas,
    empresaSelecionada: state.empresaSelecionada,
  });

export default connect(mapStateToProps, {
  cancelarReservas,
  changeFieldValue
})(reduxForm({
  form: 'formularioCancelamentoReserva',
  enableReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(ModalConfirmacaoCancelamentoReserva));
